import { useParams, Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { categories, getArticlesByCategory, getCategoryBySlug } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'wenxue-shangxi');

  useEffect(() => {
    if (slug) setActiveSlug(slug);
  }, [slug]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [activeSlug]);

  const currentCategory = getCategoryBySlug(activeSlug);
  const categoryArticles = getArticlesByCategory(activeSlug);

  return (
    <main className="pt-20 min-h-screen bg-background-50">
      {/* Breadcrumb */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-4">
        <nav className="flex items-center gap-2 text-xs text-foreground-400" aria-label="Breadcrumb">
          <Link to="/" className="hover:text-foreground-700 transition-colors">首页</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-foreground-700">{currentCategory?.name || '分类'}</span>
        </nav>
        {/* Breadcrumb Schema */}
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://ibfdxic.cn/" },
            { "@type": "ListItem", "position": 2, "name": currentCategory?.name || '分类', "item": `https://ibfdxic.cn/category/${activeSlug}` }
          ]
        }) }} />
      </div>

      {/* Header */}
      <section className="max-w-7xl mx-auto px-4 md:px-6 pb-8">
        <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-2">
          {currentCategory?.name || '分类'}
        </h1>
        <p className="text-foreground-500 text-sm">
          {currentCategory?.description || ''}
        </p>
      </section>

      {/* Category Tabs */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 pb-8 border-b border-background-200/70">
        <div className="flex items-center gap-2 flex-wrap">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              onClick={() => setActiveSlug(cat.slug)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                activeSlug === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200/70'
              }`}
            >
              <i className={`${cat.icon} mr-1.5`}></i>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>

      {/* Articles Grid */}
      <section className="max-w-7xl mx-auto px-4 md:px-6 py-10">
        {categoryArticles.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {categoryArticles.map((article) => (
              <ArticleCard
                key={article.id}
                title={article.title}
                slug={article.slug}
                excerpt={article.excerpt}
                imageUrl={article.imageUrl}
                author={article.author}
                publishDate={article.publishDate}
                readTime={article.readTime}
                categoryName={categories.find((c) => c.id === article.category)?.name}
              />
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <i className="ri-inbox-line text-4xl text-foreground-300 mb-4 block"></i>
            <p className="text-foreground-500 text-sm">该分类下暂无文章</p>
          </div>
        )}
      </section>
    </main>
  );
}